import { render, staticRenderFns } from "./ProviderChooser.vue?vue&type=template&id=6ab61118"
import script from "./ProviderChooser.vue?vue&type=script&lang=js"
export * from "./ProviderChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports